<template>
  <div class="role-menu">
    <div style="padding: 12px 20px;">
      <el-button class="zwx-button zwx-button-icontext-28" type="primary" icon="el-icon-search" @click="search()">查询</el-button>
    </div>
    <!-- 列表展示部分 -->
    <el-table class="zwx-table" style="width: 100%;" row-key="rid" :data="dataList" border stripe>
      <el-table-column prop="menuNotice" label="菜单编号" :width="$system.calWidth(dataList, 'menuNotice', '菜单编号')" header-align="left" align="left"></el-table-column>
      <el-table-column label="菜单标题" :width="$system.calWidth(dataList, 'menuTitle', '菜单标题', '\xa0\xa0\xa0\xa0\xa0\xa0')" header-align="left" align="left">
        <template slot-scope="scope">
          <template v-for="item in scope.row.menuNotice.split('.').length - 1" :row-key="item">{{ '\xa0\xa0\xa0' }}</template>
          <template>{{ scope.row.menuTitle }}</template>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" min-width="384px" header-align="left" align="left">
        <template slot-scope="scope">
          <el-checkbox class="zwx-checkbox" v-model="scope.row.ifRoleMenu" @click.native.prevent="$system.msgbox(scope.row, '提示', scope.row.ifRoleMenu ? '确定要取消授权吗？' : '确定要授权吗？', '确定', '取消', addRoleMenu)">查看</el-checkbox>
          <template v-if="scope.row.menuType !== 0">
            <el-checkbox class="zwx-checkbox" v-for="(item, index) in scope.row.btnList" v-model="item.ifRoleMenuBtn" @click.native.prevent="scope.row.ifRoleMenu && $system.msgbox(item, '提示', item.ifRoleMenuBtn ? '确定要取消授权吗？' : '确定要授权吗？', '确定', '取消', modifyRoleMenuBtnAuthState)" :disabled="!scope.row.ifRoleMenu" :key="index">{{ item.btnName }}</el-checkbox>
          </template>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: 'RoleMenu',
  data() {
    return {
      api: this.$store.state.api,
      users: this.$store.state.users,
      rid: this.$route.params.rid,
      roleName: this.$route.params.roleName,
      dataList: [],
    }
  },
  created() {
    this.$emit('breadcrumb', this.roleName, false)
  },
  mounted() {
    this.search()
  },
  computed: {},
  methods: {
    search() {
      this.$emit('loading', true)
      let data = { rid: this.rid }
      this.$system.get(this.api + '/systematic/getRoleMenuBtnList-1', data, true, true, this.searchSuccess, this.error)
    },
    searchSuccess(data) {
      if (data.type === '00') {
        this.dataList = data.menuList
      } else if (data.type === '99') {
        this.$router.push({ name: 'ErrorPage', params: { mess: data.mess } })
      } else {
        this.$system.notify('错误', data.mess, 'error')
      }
      this.$emit('loading', false)
    },
    addRoleMenu(row) {
      this.$emit('loading', true)
      let data = {
        roleId: this.rid,
        menuId: row.rid,
        ifCheck: !row.ifRoleMenu,
      }
      this.$system.post(this.api + '/systematic/addRoleMenu-1', data, true, true, this.authSuccess, this.error)
    },
    modifyRoleMenuBtnAuthState(row) {
      this.$emit('loading', true)
      let data = {
        roleId: this.rid,
        menuId: row.fkByMenuId.rid,
        btnId: row.rid,
        ifAuth: !row.ifRoleMenuBtn,
      }
      this.$system.post(this.api + '/systematic/modifyRoleMenuBtnAuthState-1', data, true, true, this.authSuccess, this.error)
    },
    authSuccess(data) {
      if (data.type === '00') {
        this.search()
      } else if (data.type === '99') {
        this.$router.push({ name: 'ErrorPage', params: { mess: data.mess } })
      } else {
        this.$system.notify('错误', data.mess, 'error')
        this.$emit('loading', false)
      }
    },
    error() {
      this.$system.notify('错误', '网络连接失败', 'error')
      this.$emit('loading', false)
    },
  },
}
</script>

<style lang="less" scoped></style>

<style lang="less"></style>
